<template>
    <div v-shortkey="['esc']" @shortkey="showModal = false" @keyup.up="up()" @keyup.down="down()" @keyup.enter="enter()">
        <div class="input-group input-group-md">
            <input :class="{ 'has-danger': $props.showTextDangerPaciente }" type="text" class="form-control" :disabled="true" :value="$props.nomePacienteRecuperado ? $props.nomePacienteRecuperado : pacienteSelecionado.nome" />
            <span class="input-group-btn">
                <button ref="btnBuscarPaciente" v-shortkey="['alt', '2']" @shortkey="(showModal = true), focoNomePaciente()" :class="{ 'btn-danger': $props.showTextDangerPaciente, 'btn-default': !$props.showTextDangerPaciente }" type="button" @click="(showModal = true), focoNomePaciente()" class="btn btn-flat"><i class="fa fa-search"></i></button>

                <router-link v-if="!regulador" target="_blank" :to="'/cadastros/pacientes/editar/' + this.pacienteSelecionado.id">
                    <button ref="btnBuscarEditar" :class="{ 'btn-danger': $props.showTextDangerPaciente, 'btn-default': !$props.showTextDangerPaciente }" type="button" class="btn btn-flat"><i class="fa fa-pencil"></i></button>
                </router-link>

                <button ref="btnBuscarLimpar" :class="{ 'btn-danger': $props.showTextDangerPaciente, 'btn-default': !$props.showTextDangerPaciente }" type="button" @click="limpar()" class="btn btn-flat"><i class="fa fa-trash-o"></i></button>
            </span>
        </div>
        <transition name="modal">
            <div class="modal-mask" v-show="showModal">
                <div class="modal-container" v-show="!showFormAddPaciente">
                    <div class="modal-header">
                        <h3>Selecionar Paciente</h3>
                    </div>
                    <div class="modal-body">
                         <div class="row">
                            <div class="col-sm-5">
                                <div class="form-group">
                                    <label for="">Nome do paciente</label>
                                    <input ref="inputPaciente" title="[ ctrl + b ] Para pesquisar" type="text" class="form-control" v-model="filtros.nome" />
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="form-group">
                                    <label for="">Nome da mãe</label>
                                    <input type="text" class="form-control" v-model="filtros.nome_mae" />
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="">CPF</label>
                                    <input type="text" v-mask="'###.###.###-##'" class="form-control" v-model="filtros.cpf" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="">Dt. Nasc</label>
                                    <input type="date" class="form-control" v-model="filtros.data_nascimento" />
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="">RG</label>
                                    <input type="text" class="form-control" v-model="filtros.rg" />
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label for="">CNS</label>
                                    <input type="text" class="form-control" v-model="filtros.cartao_sus" />
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label for="">Municipio</label>
                                    <input type="text" class="form-control" v-model="filtros.municipio" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="">&nbsp;</label>
                                    <button @click="getDataTable()" v-shortkey="['ctrl', 'b']" @shortkey="getDataTable()" title="[ ctrl + b ] Para pesquisar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="loading">
                            <div class="col-sm-12" style="text-align: center; margin-top:30px;">
                                <br />
                                <span style="text-align: center">Aguarde, processando...</span>
                            </div>
                        </div>

                        <div class="row" style="margin-top:15px" v-else>
                            <div class="col-sm-12 table-responsive">
                                <table role="grid" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%">CNS</th>
                                            <th style="width: auto">Nome</th>
                                            <th style="width: auto">RG</th>
                                            <th style="width: auto">Sexo</th>
                                            <th style="width: auto">Dt. Nascimento</th>
                                            <th style="width: auto">Idade</th>
                                            <th style="width: auto">Mãe</th>
                                            <th style="width: auto">CPF</th>
                                            <th style="width: auto">Município</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr @click="seleciona(item)" :class="{ ativa: index === pacienteSelecionadoIndex }" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="index">
                                            <td>{{ item.cartao_sus }}</td>
                                            <td>{{ item.nome }}</td>
                                            <td>{{ item.rg }}</td>
                                            <td>{{ item.sexo }}</td>
                                            <td>{{ item.data_nascimento | dataFormatada }}</td>
                                            <td>{{ item.data_nascimento | idade }}</td>
                                            <td>{{ item.nome_mae }}</td>
                                            <td>{{ item.cpf }}</td>
                                            <td>{{ item.cidade.nome }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-right" style="float:right">
                            <button type="button" ref="btnPaciente" class="btn btn-default" @click="showModal = false"><i class="fa fa-close"></i> Fechar</button>
                            <button v-if="!regulador" @click="showFormAddPaciente = true" type="button" ref="btnPaciente" class="btn btn-primary"><i class="fa fa-plus"></i> Novo paciente</button>
                        </div>
                    </div>
                </div>
                <form-add-paciente v-if="!regulador"
                    :cidade-unidade-solicitante="$props.cidadeUnidadeSolicitante"
                    @pacienteSelecionado="
                        paciente => {
                            seleciona(paciente);
                        }
                    "
                    @close="showFormAddPaciente = false"
                    v-show="showFormAddPaciente"
                ></form-add-paciente>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import formAddPaciente from "./formAddPaciente";
import { mask } from "vue-the-mask";
export default {
    props: ["regulador", "nomePaciente", "showTextDangerPaciente", "cidadeUnidadeSolicitante", "nomePacienteRecuperado", "unidadeSolicitante"],
    components: {
        formAddPaciente
    },
    directives: {
        mask
    },
    data: () => ({
        showFormAddPaciente: false,
        loading: false,
        pacienteSelecionadoIndex: 0,
        pacienteSelecionado: {
            nome: null
        },
        filtros: {
            nome: "",
            nome_mae: "",
            data_nascimento: "",
            rg: "",
            cartao_sus: "",
            municipio: "",
            cpf: ""
        },
        showModal: false,
        dataTable: {
            data: []
        }
    }),
    mounted() {
        // this.getDataTable();
        this.pacienteSelecionadoIndex = 0;
    },
    methods: {
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.cidadeUnidadeSolicitante = this.$props.cidadeUnidadeSolicitante;
            this.filtros.unidadeSolicitante = this.$props.unidadeSolicitante;
            this.$store.commit("TOGGLE_LOADING");

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        },
        limpar() {
            this.seleciona({
                id: null,
                nome: "",
                nome_mae: "",
                data_nascimento: "",
                rg: "",
                cartao_sus: "",
                cidade: {
                    nome: ""
                }
            });
            this.$emit("limpar");
        },
        seleciona(item) {
            this.pacienteSelecionado = item;
            this.showModal = false;
            this.showFormAddPaciente = false;
            this.$emit("setPacienteSelecionado", item);
        },
        focus() {
            this.$refs.btnBuscarPaciente.focus();
        },
        abrirModal() {
            this.$refs.btnBuscarPaciente.click();
        },
        focoNomePaciente() {
            this.$nextTick(function() {
                this.$refs.inputPaciente.focus();
            });
        },
        up() {
            if (this.pacienteSelecionadoIndex > 0) {
                this.pacienteSelecionadoIndex--;
            }
        },
        down() {
            if (this.pacienteSelecionadoIndex < this.dataTable.data.length - 1) {
                this.pacienteSelecionadoIndex++;
            }
        },
        enter() {
            if (!this.showFormAddPaciente) {
                if (this.dataTable.data[this.pacienteSelecionadoIndex]) {
                    this.seleciona(this.dataTable.data[this.pacienteSelecionadoIndex]);
                }
            }
        }
    },
    watch: {
        "$props.nomePaciente": function(value) {
            if (value) {
                this.pacienteSelecionado.nome = value;
            }
        },
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

table {
    font-size: 12px;
}

.modal-mask {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 90%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    margin: 10px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
			 * The following styles are auto-applied to elements with
			 * transition="modal" when their visibility is toggled
			 * by Vue.js.
			 *
			 * You can easily play with the modal transition by editing
			 * these styles.
			 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 350px;
    overflow-y: auto;
}

.has-danger {
    border-color: #d73925;
}
</style>



// WEBPACK FOOTER //
// selectPaciente.vue?33a6f5f2